/*
 * Developed by quentinmalguy on 4/25/19 3:39 PM from Malguy Technology.
 * Last modified 4/25/19 3:36 PM.
 */

export const selectDocumentsList = (store) => store.documents.list;
export const selectDocumentsListSize = (store) => store.documents.listSize;
export const selectDocumentsLoading = (store) => store.documents.loading;
